import * as C from '../../actionTypes/bookings/list'

export const listBookings = () => ({type: C.LIST_BOOKING })
export const changePage = (payload) => ({ type: C.CHANGE_PAGE, payload })
export const changeTab = (payload) => ({ type: C.CHANGE_TAB, payload })
export const changePaymentStatusesFilter = (payload) => ({ type: C.CHANGE_PAYMENT_STATUSES_FILTER, payload })
export const changeBookingStatusesFilter = (payload) => ({ type: C.CHANGE_BOOKING_STATUSES_FILTER, payload })
export const submitFilter = () => ({ type: C.SUBMIT_FILTER })